Object.defineProperty(exports, "__esModule", { value: true });
exports.contentModelByIds = void 0;
exports.contentModelByIds = (contentTypes) => {
    return contentTypes.items.reduce((outerResult, contentType) => {
        outerResult[contentType.name] = contentType.fields.reduce((innerResult, field) => {
            innerResult[field.id] = field;
            return innerResult;
        }, {});
        return outerResult;
    }, {});
};
//# sourceMappingURL=content-model-by-ids.js.map